import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';

import DefaultSubHeader from '../../../_metronic/layout/sub-header/DefaultSubHeader';
import { HeadBandHelper } from '../../helpers/HeadBandHelper';
import { actions } from '../../store/route/route.store';
import DimensionsHandler from '../content/DimensionsHandler';
import RouteSwitch from '../content/RouteSwitch';

import ErrorFallback from './ErrorFallback';

function PageLayout(props) {
    const dispatch = useDispatch();
    const prevRoute = useSelector((state) => state.route.prevRoute);
    const prevMatchPath = prevRoute?.match?.path;
    const prevLocationPath = prevRoute?.location?.pathname;
    const [subHeaderElement, setSubHeaderElement] = useState(undefined);
    const methods = useForm();

    useEffect(() => {
        setSubHeaderElement(document.getElementById('kt-content-subheader'));
    }, []);

    useEffect(() => {
        HeadBandHelper.updateSubHeader();
    });

    useEffect(() => {
        dispatch(
            actions.setRoute({
                match: props.match,
                location: props.location,
            }),
        );
    }, []);

    const SubHeader = props.subheader === undefined ? DefaultSubHeader : props.subheader;
    const Main = props.main;

    useEffect(() => {
        if (!SubHeader) {
            document.body.classList.remove('kt-subheader--enabled', 'kt-subheader--fixed');
            HeadBandHelper.updateSubHeader();
            return () => {
                document.body.classList.add('kt-subheader--enabled', 'kt-subheader--fixed');
            };
        }
    }, [SubHeader]);

    return (
        <ErrorBoundary
            fallbackRender={({ resetErrorBoundary }) => (
                <ErrorFallback prevLocationPath={prevLocationPath} resetErrorBoundary={resetErrorBoundary} />
            )}
        >
            <RouteSwitch prevMatchPath={prevMatchPath} />
            <FormProvider {...methods}>
                {subHeaderElement && (
                    /* Handle resize dimensions */
                    <DimensionsHandler>
                        {SubHeader && ReactDOM.createPortal(<SubHeader />, subHeaderElement)}
                        <Main />
                    </DimensionsHandler>
                )}
            </FormProvider>
        </ErrorBoundary>
    );
}

export default withRouter(PageLayout);
